import LeadToSnug from 'app/match/leadToSnug/container'

export default LeadToSnug
